import { AnalyticsType, TStoreSeachViewType } from "./model";

export const filterLocationsPayload = (
  filter_type: string,
  view_type: TStoreSeachViewType
): AnalyticsType => ({ filter_type, view_type });
